<div class="t-popup popup-patientDetails" cdkDrag>
    <div class="t-popup-close"></div>
    <div class="t-popup-frame" style="display: flex; flex-direction:column;">
        <div  [ngClass]="page === 'Patients' ? 'popup-nav-patients' :'popup-nav-calendar'">
            
            <button class="search-btn " style="background-color: #6d7cab00;color: #277382;font-weight: 900;">Select Patient</button>
            <ng-container *ngIf="page!=='Patients'" >
            <img class="w10" src="assets/images/arr-right.svg"/>
            <button class="search-btn " style="background-color: #6d7cab00;" >Patient Details</button>
            <img class="w10" src="assets/images/arr-right.svg"/>
            <button class="search-btn" style="background-color: #6d7cab00;" >Appointment</button>
          </ng-container>
        </div>
        <button class="t-btn-popup-close" aria-label="close popup" (click)="closePatientModal()" ></button>
      <div class="t-popup-body" style="height: 60vh;">
       
        <div style="display: flex;flex-direction: row;height: 100%;">
          
            <div class="userPanel">
                <div class="search-patient">
    
                    <div class="search-patient-field">
                        <div class="t-field l-flex t-twin-fieldset">
                            <label>
                                <input type="radio" name="idp" [(ngModel)]="idp" [value]="1" class="custom-check customInput" aria-labelledby="pregnancy_popup-sex">
                                <i class="customInput-display"></i>
                                <span class="t-field-desc">
                                    ID
                                </span>
                            </label>
                            <label>
                                <input type="radio" name="idp" [(ngModel)]="idp" [value]="0" class="custom-check customInput" aria-labelledby="pregnancy_popup-sex">
                                <i class="customInput-display"></i>
                                <span class="t-field-desc">
                                    Passport
                                </span>
                            </label>
                        </div>
                    </div>
    
                    <div class="t-validation-wrap">
                        <input type="text" class="search-patient-field idnumber" [ngClass]="invalidi" placeholder="ID Number" [attr.type]="idp == 1 ? 'number' : 'text'" [(ngModel)]="id" (keyup)="invalidi='';trysearch()" pattern="[A-Za-z0–9\-]+">
                        <div class="t-validation-message">
                            <span>Invalid ID Number</span>
                        </div>
                    </div>
    
                    <div class="t-validation-wrap">
                        <input type="text" class="search-patient-field" placeholder="First Name" [ngClass]="invalidf" [(ngModel)]="first" (keyup)="invalidf='';trysearch()">
                        <div class="t-validation-message">
                            <span>Please fill in first name</span>
                        </div>
                    </div>
    
                    <div class="t-validation-wrap">
                        <input type="text" class="search-patient-field" placeholder="Last Name" [ngClass]="invalidl" [(ngModel)]="last" (keyup)="invalidl='';trysearch()">
                        <div class="t-validation-message">
                            <span>Please fill in last name</span>
                        </div>
                    </div>
                    
                    <div class="t-validation-wrap">
                        <input type="tel" class="search-patient-field" placeholder="Phone" [(ngModel)]="phone">
                        <div class="t-validation-message">
                            <span>Invlid phone</span>
                        </div>
                    </div>
    
                    <div class="l-flex l-flex-w t-fieldmargin search-btns">
                      
                        <div class="w50">
                            <button class="search-btn" matTooltipPosition="after" (click)="search(true);isReports=false;reportList=null" matTooltip="Search Patient">Search</button>
                        </div>
                        <div class="w50">
                            <button class="search-btn"   matTooltipPosition="after" (click)="clear()" [ngClass]="id.length > 0 || last.length>0 || first.length > 0 || phone.length > 0 ? '' : 'search-btn--clear'" matTooltip="Clear Search Fields">Clear</button>
                        </div>
                        <div class="w100">
                            <button class="search-btn search-btn--newPatient"   matTooltipPosition="after" (click)="addPatient();isReports=false" matTooltip="Open New Patient">New Patient</button>
                        </div>
    
                    </div>
                </div>
   
            </div>
          <div style="overflow-y: scroll; height: 90%;" *ngIf="patList && patList.length">
            <div class="l-flex patient-item" *ngFor="let pat of patList">
    
                <button class="w100 patient-item-link" (click)="selectedPatient=pat;patservice.setPat(pat);closePatientModal('patDetails')" matTooltip="select patient">
    
                    <div class="l-table h100">
    
                        <span class="l-td-m patient-item-cell patient-id">
                            {{pat.IsID?'ID' : 'Passport'}}: <strong>{{pat.ID}}</strong>
                        </span>
    
                        <span class="l-td-m patient-item-cell patient-name-first">
                            {{pat.First}}
                        </span>
    
                        <span class="l-td-m patient-item-cell patient-name-last">
                            {{pat.Last}}
                        </span>
                        <!-- <span class="l-td-m patient-item-cell patient-name-first" *ngIf="loginService.separatedClinic && (loginService.isAdmin || loginService.userType == 'secretary')">
                            {{loginService.getDocByUID(pat.UID)}}
                        </span> -->
    
                    </div>			
    
                </button>
    
            </div>
        </div>
    </div>
           
           
            
    
      
    </div>
  </div>
</div>
  